export default "__VITE_ASSET__BQEu8ATy__"